import styled from 'styled-components';

import { Colors } from '@formstack/phoenix/components/colors/constants';

import { useResource } from '@/common/resources';

import { AppList } from '../AppList';
import { ConnectedAppItemActions } from './components/ConnectedAppItemActions';
import { IConnectedAppItemActions } from './components/ConnectedAppItemActions/interface';
import { IConnectedApps } from './interface';

const SUB_HEADING_VERTICAL_PADDING = '0.75em';
const StyledHeading = styled.div`
  font-size: 1.75em;
  font-weight: 600;
  color: ${Colors['phx-black']};
  padding-bottom: ${SUB_HEADING_VERTICAL_PADDING};
`;
const StyledSubHeading = styled.div`
  font-size: 1.5em;
  font-weight: 500;
  color: ${Colors['phx-gray-4']};
  padding-bottom: ${SUB_HEADING_VERTICAL_PADDING};
`;
const StyledSubHeadingWithTopPadding = styled(StyledSubHeading)`
  padding-top: ${SUB_HEADING_VERTICAL_PADDING};
`;

const getBifurcatedAppListStructure = (
  apps: IConnectedAppItemActions[] = []
): {
  connectedApps: IConnectedAppItemActions[];
  availableApps: IConnectedAppItemActions[];
} => {
  const connectedApps: IConnectedAppItemActions[] = [];
  const availableApps: IConnectedAppItemActions[] = [];

  for (const a of apps) {
    if (a.isConnected) {
      connectedApps.push(a);
    } else {
      availableApps.push(a);
    }
  }

  return {
    connectedApps,
    availableApps,
  };
};

const ConnectedApps = ({ apps = [] }: IConnectedApps) => {
  const resource = useResource((resource) => ({
    appConnections: resource.appConnections,
    connected: resource.connected,
    availableApps: resource.availableApps,
  }));

  const { connectedApps, availableApps } = getBifurcatedAppListStructure(apps);
  const hasConnected: boolean = connectedApps?.length > 0;
  const hasAvailable: boolean = availableApps?.length > 0;

  return (
    <>
      <StyledHeading>{resource.appConnections}</StyledHeading>
      {hasConnected ? (
        <>
          <StyledSubHeading>{resource.connected}</StyledSubHeading>
          <AppList apps={connectedApps} actionComponent={ConnectedAppItemActions} />
        </>
      ) : undefined}
      {hasAvailable && (
        <>
          <StyledSubHeadingWithTopPadding>{resource.availableApps}</StyledSubHeadingWithTopPadding>
          <AppList apps={availableApps} actionComponent={ConnectedAppItemActions} />
        </>
      )}
    </>
  );
};

export { ConnectedApps };
